/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".boxForm[_ngcontent-%COMP%]{border:2px solid #eb904b;padding:8px}"];
export { styles as styles };
